module.exports = __webpack_public_path__ + "img/mobile_phn.png";